import { useEffect, useState } from 'react'
import { getAnonId } from './identity'
import { setClarity } from './clarity'
import TagManager from 'react-gtm-module'
import { i18n } from '@lingui/core'

export const useAnalytics = (
  trackVisitEvent?: string,
  sendLanguage: boolean = false
) => {
  const [anonId, setAnonId] = useState<string | null>(null)

  useEffect(() => {
    const fetchAnonId = async () => {
      const id = getAnonId()
      setAnonId(id)
    }

    fetchAnonId()
  }, [])

  useEffect(() => {
    if (!anonId) return

    setClarity('anon_id', anonId)

    if (sendLanguage) {
      setClarity('language', i18n.locale)
    }

    if (trackVisitEvent) {
      const dataLayerPayload: Record<string, any> = {
        event: trackVisitEvent,
        anon_id: anonId,
      }

      if (sendLanguage) {
        dataLayerPayload.language = i18n.locale
      }

      TagManager.dataLayer({ dataLayer: dataLayerPayload })
      setClarity(trackVisitEvent, true)
    }
  }, [anonId, trackVisitEvent, sendLanguage])

  const trackClarity = (key: string, value: any = true) => {
    setClarity(key, value)
  }

  const trackGtm = (event: string, data: Record<string, any> = {}) => {
    if (!anonId) return
    TagManager.dataLayer({
      dataLayer: {
        event,
        anon_id: anonId,
        ...data,
      },
    })
  }

  return { anonId, trackClarity, trackGtm }
}
